module.exports = __webpack_public_path__ + "img/marker-bar.76bc6ff3.png";